import RequestService, {
    RequestServiceResponse,
} from '@tcc-online/request-service';
import { StorageService } from './StorageService';
import IIntegrationParams from '../../types/integration/IIntegrationParams';
import { NotificationActions } from '../../common/actions/NotificationActions';
import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import IIntegration from '../../types/integration/IIntegration';

const ENDPOINT = '/integrations';
const PARAMS_KEY = 'INTEGRATION_QUERY_PARAMS';

const IntegrationService = {
    getIntegration,
    enableIntegration,
    setParams,
    removeParams,
    getParams,
};

async function getIntegration(
    payload: IIntegrationParams,
    api: GetThunkAPI<any>,
): Promise<RequestServiceResponse<IIntegration>> {
    const { integrator, companyId } = payload;

    try {
        return await RequestService.get<IIntegration>(
            `${ENDPOINT}/${integrator}/${companyId}`,
        );
    } catch (ex) {
        api.dispatch(
            NotificationActions.error('fe.error.insufficient-permissions'),
        );

        throw ex;
    }
}

async function enableIntegration(
    payload: IIntegrationParams,
    api: GetThunkAPI<any>,
): Promise<RequestServiceResponse> {
    const { integrator, companyId } = payload;

    try {
        return await RequestService.patch(
            `${ENDPOINT}/${integrator}/${companyId}`,
            { enabled: true },
        );
    } catch (ex) {
        api.dispatch(
            NotificationActions.error('fe.error.integration-activation-failed'),
        );

        throw ex;
    }
}

function setParams(params: string): void {
    StorageService.setSession(PARAMS_KEY, params);
}

function removeParams(): void {
    StorageService.deleteSession(PARAMS_KEY);
}

function getParams(): string | undefined {
    return StorageService.getSession(PARAMS_KEY, undefined);
}

export default IntegrationService;
